export const PROJECT_STATUS_FILTER = {
  ALL_PROJECTS: 'ALL_PROJECTS',
  UNARCHIVED_PROJECTS: 'UNARCHIVED_PROJECTS',
  CUSTOM_STATUS: 'CUSTOM_STATUS'
};
